import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { NetzzuordnungIdImportJob } from '../../domain/model/netzzuordnung-id-import-job';

@Injectable({
    providedIn: 'root',
})
export class ImportNzIdWizardUploadService {
    private http = inject(HttpClient);

    public async uploadCsvAsync(file: File, dryRun: boolean): Promise<number> {
        const formData = new FormData();
        formData.append('file', file);

        let params = new HttpParams();
        params = params.set('dryrun', dryRun);

        return await lastValueFrom(
            this.http.post<number>(
                `${environment.API_URL}/admin/netzzuordnung/netzzuordnungIds/import`,
                formData,
                { params },
            ),
        );
    }

    public async checkImportJob(jobId: number): Promise<NetzzuordnungIdImportJob> {
        return await lastValueFrom(
            this.http.get<NetzzuordnungIdImportJob>(
                `${environment.API_URL}/admin/netzzuordnung/netzzuordnungIds/job/${jobId}`,
            ),
        );
    }

}
